// PlayerCard.js
import React from 'react';
import { motion } from 'framer-motion';

const PlayerCard = ({ nickname, fullName, image }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.3 }}
      className="relative overflow-hidden rounded-xl bg-brand-red"
    >
      <div className="aspect-[3/4]">
        <img
          src={image || "/api/placeholder/240/320"}
          alt={nickname}
          className="w-full h-full object-contain"
        />
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 via-black/60 to-transparent">
        <h3 className="text-2xl font-helvetica font-bold text-brand-white">{nickname.toUpperCase()}</h3>
        <p className="text-md font-helvetica text-brand-white/80">{fullName.toUpperCase()}</p>
      </div>
    </motion.div>
  );
};

export default PlayerCard;